import { Carrier } from "../models/carrier";
import BaseService from "./_base.service";

const endpoint = "carriers";

const CarrierService = {
  ...BaseService<Carrier>({ endpoint }),
};

export default CarrierService;
